// Client-side CSV generation + download for extracted contacts.
// No backend involved — Phase 1 keeps the download completely free/frictionless.
import { Contact, ContactField } from "../types/cardToCrm.types";

// Column order + headers per docs/card-to-crm-plan.md "CSV Format".
const COLUMNS: { field: ContactField; header: string }[] = [
  { field: "name", header: "Name" },
  { field: "title", header: "Title" },
  { field: "company", header: "Company" },
  { field: "email", header: "Email" },
  { field: "phone", header: "Phone" },
  { field: "mobile", header: "Mobile" },
  { field: "website", header: "Website" },
];

/** RFC-4180 escaping: wrap in quotes if the value contains a comma, quote, or newline. */
const escapeCell = (value: string | null): string => {
  const cell = value ?? "";
  if (/[",\n\r]/.test(cell)) {
    return `"${cell.replace(/"/g, '""')}"`;
  }
  return cell;
};

/** Serialize the in-memory contact list to a CSV string. */
export const contactsToCsv = (contacts: Contact[]): string => {
  const header = COLUMNS.map((c) => c.header).join(",");
  const rows = contacts.map((contact) =>
    COLUMNS.map((c) => escapeCell(contact[c.field])).join(",")
  );
  return [header, ...rows].join("\r\n");
};

/** Trigger a browser download of `csv` as `filename`. */
export const downloadCsv = (filename: string, csv: string): void => {
  // Prepend a UTF-8 BOM so Excel opens accented characters correctly.
  const blob = new Blob(["﻿", csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
